import {
  faIdBadge,
  faBook,
  faStar,
  faUser,
  faUserCheck
} from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import store from 'app/store';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableControlBar from 'components/common/advance-table/AdvanceTableControlBar';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import Avatar from 'components/common/Avatar';
import CardDropdown from 'components/common/CardDropdown';
import Flex from 'components/common/Flex';
import draftEntryUiHelper from 'helpers/draft-entry-ui-helper';
import segmentHelper from 'helpers/segment-helper';
import userHelper from 'helpers/userHelper';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import Lightbox from 'react-18-image-lightbox';
import {
  Button,
  Card,
  Col,
  Dropdown,
  ListGroup,
  OverlayTrigger,
  Placeholder,
  Row,
  Spinner,
  Tooltip
} from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Alert, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import {
  showAlert,
  showConfirm,
  showMasterSignerDialog,
  showViewEntryDialog
} from 'stores/modal';

import api from 'util/api';
import c from 'util/const';
import filters from 'util/filters';
import logger from 'util/logger';
import utils from 'util/utils';
import { FaStickyNote } from 'react-icons/fa';
import SoftBadge from 'components/common/SoftBadge';
import Colors from 'util/Colors';
import enums from 'util/enums';

const ViewEntryDialog = ({
  entry_guid,
  isFrom,
  close,
  // showAlert,
  // showConfirm,
  app
}) => {
  const [signerList, setSignerList] = useState({});
  const [changesMade, setChangesMade] = useState(false);
  const [loading, setLoading] = useState(false);
  const [localTimezone, setLocalTimeZone] = useState(null);
  const [isDisplayProfilePic, SetIsDisplayProfilePic] = useState(false);
  const dispatch = useDispatch();
  let { subscriptionStatus } = store.getState().subscription;
  let activeSubscriptions = _.get(subscriptionStatus, 'Active', []);

  const loadEntry = () => {
    setLoading(true);
    api.masterSigner
      .get(entry_guid, true)
      .then(res => {
        logger.log('get master client list ', res);
        setSignerList(res);
        setLocalTimeZone(
          userHelper.getTimezoneVal(
            store.getState()?.app?.userMaster?.LocalTimezone
          )
        );
        setLoading(false);
      })
      .catch(err => {
        logger.log('error loading entry', err);
        dispatch(
          showAlert(
            'Unable to Load Entry',
            'There was a problem loading your entry.  Please try again.',
            () => {
              closeModal(changesMade);
            }
          )
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadEntry();
  }, []);

  const renderSigner = () => {
    let hasAddressField = !!(
      (signerList?.Address1 && signerList?.Address1?.length > 0) ||
      (signerList?.Address2 && signerList?.Address2?.length > 0)
    );
    let hasAreaField = !!(
      (signerList?.City && signerList?.City?.length > 0) ||
      (signerList?.State && signerList?.State?.length > 0) ||
      (signerList?.PostalCode && signerList?.PostalCode?.length > 0)
    );
    return (
      signerList &&
      signerList?.FirstName && (
        <Card className="mb-2">
          <Card.Header>
            <h5>
              <FontAwesomeIcon icon={faUser} size="lg" className="me-3" />
              Client
            </h5>
          </Card.Header>
          <hr className="my-0" />
          <Card.Body>
            <Row>
              <Col sm={12} md={6}>
                <div className="master client">
                  <div
                    className="pointer"
                    onClick={() => SetIsDisplayProfilePic(true)}
                  >
                    <p className="mb-1">
                      <span className="fw-semi-bold">Client Picture: </span>
                    </p>
                    <Avatar
                      size="4xl"
                      src={
                        signerList.Blob && signerList.Blob.Data
                          ? `data:image/png;base64,${signerList.Blob.Data}`
                          : ''
                      }
                      name={
                        signerList
                          ? signerList?.signer_first_name +
                            ' ' +
                            signerList?.signer_last_name
                          : ''
                      }
                      mediaClass="img-thumbnail shadow-sm"
                    />
                  </div>
                  {isDisplayProfilePic && (
                    <Lightbox
                      mainSrc={
                        signerList?.Blob && signerList?.Blob?.Data
                          ? `data:image/png;base64,${signerList?.Blob?.Data}`
                          : '/default_user_profile.jpg'
                      }
                      onImageLoad={() => {
                        window.dispatchEvent(new Event('resize'));
                      }}
                      reactModalStyle={{ overlay: { zIndex: 999999 } }}
                      onCloseRequest={() => SetIsDisplayProfilePic(false)}
                    />
                  )}

                  <p className="mb-1">
                    <span className="fw-semi-bold">Name: </span>
                    {signerList.Prefix} {signerList.FirstName}{' '}
                    {signerList.MiddleName} {signerList.LastName}{' '}
                    {signerList.Suffix}{' '}
                  </p>

                  <p className="mb-1">
                    <span className="fw-semi-bold">Email: </span>
                    {signerList.EmailAddress}
                  </p>
                  <p className="mb-1">
                    <span className="fw-semi-bold">Phone Number: </span>
                    {signerList.Telephone}
                  </p>
                  <p className="mb-1">
                    <span className="fw-semi-bold">Address: </span>
                    {hasAddressField && (
                      <>
                        {signerList.Address1 && signerList.Address1.length > 0
                          ? signerList.Address1
                          : ''}{' '}
                        {signerList.Address2 && signerList.Address2.length > 0
                          ? signerList.Address2
                          : ''}{' '}
                      </>
                    )}
                    {hasAreaField && (
                      <>
                        {signerList.City && signerList.City.length > 0
                          ? signerList.City + ', '
                          : ''}
                        {signerList.State && signerList.State.length > 0
                          ? signerList.State + ', '
                          : ''}
                        {signerList.PostalCode &&
                        signerList.PostalCode.length > 0
                          ? signerList.PostalCode
                          : ''}
                      </>
                    )}
                  </p>
                  <p className="mb-1">
                    <span className="fw-semi-bold">General Notes: </span>
                    {signerList.AdditionalData}
                  </p>
                  <p className="mb-1">
                    <span className="fw-semi-bold">
                      Colleague:
                      <FontAwesomeIcon
                        className={signerList.IsFavorite ? 'text-primary' : ''}
                        icon={signerList.IsFavorite ? faStar : faStarRegular}
                      />
                    </span>
                  </p>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )
    );
  };
  const renderIdentifications = () => {
    return (
      <>
        {signerList?.Identifications && (
          <Card className="mb-2">
            <Card.Header>
              <h5>
                {/* <FaListAlt />  */}
                <FontAwesomeIcon icon={faIdBadge} size="lg" className="me-3" />
                Identifications
              </h5>
            </Card.Header>
            <hr className="my-0" />
            <Card.Body>
              <Row>
                <Col sm={12} md={6}>
                  <div className="master identifications">
                    {signerList?.Identifications?.length == 0 ? (
                      <>Identification data not found</>
                    ) : (
                      signerList &&
                      signerList?.Identifications?.filter(indetification =>
                        isFrom === 'master' ? !indetification?.IsDeleted : true
                      )?.map((indetification, index) => {
                        return (
                          indetification.IdType !== enums.ID_TYPES.NONE && (
                            <div
                              className="mx-2 mb-2"
                              key={indetification.GUID}
                            >
                              <p className="mb-1">
                                <span className="fw-semi-bold">Type:</span>
                                <div className="ms-2 fs--2 badge badge-soft-success rounded-pill">
                                  {indetification.IdType}
                                </div>
                              </p>
                              <p className="mb-1">
                                <span className="fw-semi-bold">Name: </span>
                                {indetification.Prefix}{' '}
                                {indetification.FirstName}{' '}
                                {indetification.MiddleName}{' '}
                                {indetification.LastName}{' '}
                                {indetification.Suffix}{' '}
                              </p>
                              {indetification?.IdNumber && (
                                <p className="mb-1">
                                  <span className="fw-semi-bold">
                                    Id Number:
                                  </span>{' '}
                                  {indetification?.IdNumber}{' '}
                                </p>
                              )}
                              {indetification.IdIssued && (
                                <p className="mb-1">
                                  <span className="fw-semi-bold">
                                    Issue Date:
                                  </span>{' '}
                                  {draftEntryUiHelper
                                    .getDateTimeWithTimeZone(
                                      indetification.IdIssued
                                    )
                                    .format('MM/DD/YYYY')}
                                </p>
                              )}
                              {indetification.IdExpiration && (
                                <p className="mb-1">
                                  <span className="fw-semi-bold">
                                    Expiration Date:
                                  </span>{' '}
                                  {draftEntryUiHelper
                                    .getDateTimeWithTimeZone(
                                      indetification.IdExpiration
                                    )

                                    .format('MM/DD/YYYY')}
                                </p>
                              )}
                              {indetification.DateOfBirth && (
                                <p className="mb-1">
                                  <span className="fw-semi-bold">
                                    Date of Birth:
                                  </span>{' '}
                                  {draftEntryUiHelper
                                    .getDateTimeWithTimeZone(
                                      indetification.DateOfBirth
                                    )
                                    .format('MM/DD/YYYY')}
                                </p>
                              )}

                              <p className="mb-1">
                                <span className="fw-semi-bold">Address:</span>{' '}
                                {utils.getAddressJoiner(
                                  indetification.Address1
                                )}
                                {utils.getAddressJoiner(
                                  indetification.Address2
                                )}
                                {utils.getAddressJoiner(indetification.City)}
                                {utils.getAddressJoiner(indetification.State)}
                                {utils.getAddressJoiner(indetification.Country)}
                                {indetification.PostalCode}
                              </p>
                              {indetification.notes && (
                                <p className="mb-1">
                                  <span className="fw-semi-bold">Notes:</span>{' '}
                                  <i className="fs--1">
                                    {indetification.notes}
                                  </i>
                                </p>
                              )}
                              {index <
                                signerList?.Identifications?.length - 1 && (
                                <hr className="my-0" />
                              )}
                            </div>
                          )
                        );
                      })
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}
      </>
    );
  };
  const renderJournalDetails = () => {
    const markUpdateItemChangesinEntry = (entry, options) => {
      let entryUpdated = [];
      const { Signings } = signerList;

      _.map(Signings, s => {
        if (s.GUID === entry.GUID) {
          let newItem = _.merge(s, options);
          entryUpdated.push(newItem);
        } else {
          entryUpdated.push(s);
        }
      });
      setSignerList({ ...signerList, Signings: entryUpdated });
    };
    const handleStrikeEntry = entry => {
      if (activeSubscriptions.length === 0) {
        dispatch(
          showAlert(
            'Subscription Required',
            'You have no active subscription and your signings are queued for deletion. Reactivate your subscription in the Subscription tab.'
          )
        );
        return;
      }
      if (entry.Stricken) {
        api.Signing.unstrike(entry.GUID)
          .then(res => {
            logger.log('unstrike res', res);
            segmentHelper.track(
              segmentHelper.events.SIGNING_DETAIL_UNSTRIKE_ENTRY
            );
            toast.success(`Signing record marked Unstriken`, {
              theme: 'colored',
              position: 'bottom-center',
              icon: faUserCheck,
              toastId: 'login-success'
            });
            markUpdateItemChangesinEntry(entry, { Stricken: false });
          })
          .catch(err => {
            logger.log('error while saving unstriking entry', err);
            dispatch(
              showAlert(
                'Unable to unstrike entry',
                'There was a problem unstriking your entry.  Please try again.'
              )
            );
          });
      } else {
        dispatch(
          showConfirm(
            'Are you sure?',
            'Striking a signing will cross it out in your journal history, but the entry will remain in your journal history.  You will be able to undo this action.',
            res => {
              if (res) {
                api.Signing.strike(entry.GUID)
                  .then(res => {
                    logger.log('strike res', res);
                    segmentHelper.track(
                      segmentHelper.events.SIGNING_DETAIL_STRIKE_ENTRY
                    );
                    toast.success(`Signing record marked Striken`, {
                      theme: 'colored',
                      position: 'bottom-center',
                      icon: faUserCheck,
                      toastId: 'login-success'
                    });
                    markUpdateItemChangesinEntry(entry, { Stricken: true });
                  })
                  .catch(err => {
                    logger.log('error while saving striking entry', err);
                    dispatch(
                      showAlert(
                        'Unable to strike entry',
                        'There was a problem striking your entry.  Please try again.'
                      )
                    );
                  });
              }
            }
          )
        );
      }
    };
    const onRowClicked = entry => {
      if (activeSubscriptions.length === 0) {
        dispatch(
          showAlert(
            'Subscription Required',
            'You have no active subscription and your signings are queued for deletion. Reactivate your subscription in the Subscription tab.'
          )
        );
        return;
      }

      dispatch(showViewEntryDialog(entry.GUID));
    };

    const columns = [
      {
        accessor: 'EmailSent',
        Header: 'Mail',
        headerProps: { className: 'pe-1' },
        cellProps: {
          className: 'py-2'
        },
        Cell: rowData => {
          const { EmailSent, LocalTimezone } = rowData.row.original;
          return (
            <Flex alignItems="center">
              {EmailSent ? (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      Sent mail on:{' '}
                      {draftEntryUiHelper
                        .getDateTimeWithTimeZone(
                          EmailSent,
                          userHelper.getTimezoneVal(LocalTimezone)
                        )
                        .format(c.dateFormat)}
                    </Tooltip>
                  }
                >
                  <span>
                    <FontAwesomeIcon
                      size="xl"
                      color={Colors.success.color}
                      icon="envelope"
                      className="me-2"
                    />
                  </span>
                </OverlayTrigger>
              ) : (
                <FontAwesomeIcon size="xl" icon="envelope" className="me-2" />
              )}
            </Flex>
          );
        }
      },
      {
        accessor: 'SigningTimestamp',
        Header: 'Notarization Date and Time',
        Cell: rowData => {
          const { SigningTimestamp, Stricken, LocalTimezone } =
            rowData.row.original;
          let formattedDate = draftEntryUiHelper
            .getDateTimeWithTimeZone(
              SigningTimestamp,
              userHelper.getTimezoneVal(LocalTimezone)
            )

            .format(c.dateFormat);
          return (
            <span
              className={
                Stricken ? 'cursor-pointer text-danger' : 'cursor-pointer'
              }
              onClick={() => onRowClicked(rowData.row.original)}
              style={Stricken ? { textDecoration: 'line-through' } : {}}
            >
              {formattedDate}
            </span>
          );
        }
      },
      {
        accessor: 'Signers',
        Header: 'Signers',
        headerProps: { className: 'pe-1' },
        cellProps: {
          className: 'py-2'
        },
        Cell: rowData => {
          const { Signers, Stricken } = rowData.row.original;
          let signerName = Signers ? filters.buildSignerString(Signers) : '';
          return signerName && signerName.length > 0 ? (
            <Flex
              alignItems="center"
              onClick={() => onRowClicked(rowData.row.original)}
            >
              <Avatar
                size="xl"
                name={signerName.substring(0, 10)}
                className="me-2"
                mediaClass={
                  Stricken ? 'cursor-pointer bg-danger' : 'cursor-pointer'
                }
              />
              <div className="flex-1">
                <h5
                  className={
                    Stricken
                      ? 'mb-0 fs--1 cursor-pointer text-danger'
                      : 'mb-0 fs--1 cursor-pointer'
                  }
                  style={Stricken ? { textDecoration: 'line-through' } : {}}
                >
                  {signerName}
                </h5>
              </div>
            </Flex>
          ) : (
            <h5
              className={
                Stricken
                  ? 'mb-0 fs--1 ms-4 cursor-pointer text-danger'
                  : 'mb-0 fs--1 ms-4 cursor-pointer'
              }
              style={Stricken ? { textDecoration: 'line-through' } : {}}
            >
              -
            </h5>
          );
        }
      },
      {
        accessor: 'NotaryEntries',
        Header: 'Entries',
        Cell: rowData => {
          const { NotaryEntries, Stricken } = rowData.row.original;
          return (
            <span
              className={
                Stricken ? 'cursor-pointer text-danger' : 'cursor-pointer'
              }
              style={Stricken ? { textDecoration: 'line-through' } : {}}
              onClick={() => onRowClicked(rowData.row.original)}
            >
              {NotaryEntries.length} Document
              {NotaryEntries?.length === 1 ? '' : 's'}
            </span>
          );
        }
      },
      {
        accessor: 'NotaryFee',
        Header: 'Notary Fee',
        Cell: rowData => {
          const { NotaryFee, NotaryFeeCurrency, Stricken } =
            rowData.row.original;
          return (
            <span
              className={
                Stricken ? 'cursor-pointer text-danger' : 'cursor-pointer'
              }
              style={Stricken ? { textDecoration: 'line-through' } : {}}
              onClick={() => onRowClicked(rowData.row.original)}
            >
              {NotaryFee === 0
                ? '$0'
                : NotaryFee
                ? filters.formatCurrencyFromServer(NotaryFee, NotaryFeeCurrency)
                : '- None entered -'}
            </span>
          );
        }
      },
      {
        accessor: 'State',
        Header: 'Address',
        Cell: rowData => {
          const { State, PostalCode, Stricken } = rowData.row.original;
          return (
            <span
              className={Stricken ? 'text-danger' : ''}
              style={Stricken ? { textDecoration: 'line-through' } : {}}
            >
              {State} - {PostalCode}
            </span>
          );
        }
      },

      {
        accessor: 'none',
        Header: '',
        disableSortBy: true,
        cellProps: {
          className: 'text-end'
        },
        Cell: rowData => {
          const { Stricken } = rowData.row.original;
          return (
            <CardDropdown drop="start" iconClassName="fs--1">
              <div className="py-2">
                <Dropdown.Item
                  href="#!"
                  onClick={() => onRowClicked(rowData.row.original)}
                >
                  View
                </Dropdown.Item>
                <Dropdown.Item
                  href="#!"
                  onClick={() => handleStrikeEntry(rowData.row.original)}
                >
                  {Stricken ? 'Unstrike' : 'Strike'}
                </Dropdown.Item>
              </div>
            </CardDropdown>
          );
        }
      }
    ];

    return (
      <>
        {signerList?.Signings && (
          <Card className="mb-2">
            <Card.Header>
              <h5>
                <FontAwesomeIcon icon={faBook} size="lg" className="me-3" />
                Journal Entries
              </h5>
            </Card.Header>
            <hr className="my-0" />
            <Card.Body>
              <Row>
                <Col sm={12} md={12}>
                  <div className="master journal-details">
                    {signerList?.Signings?.length == 0 ? (
                      <>Journal entries not found</>
                    ) : (
                      <AdvanceTableWrapper
                        columns={columns}
                        data={signerList?.Signings || []}
                        selection={false}
                        sortable
                        pagination
                        perPage={100}
                        sortBy={[
                          {
                            id: 'Created',
                            desc: true
                          }
                        ]}
                      >
                        <Card className="mb-3">
                          <Card.Body className="p-0">
                            <AdvanceTableControlBar
                              table
                              rowCount={signerList?.Signings?.length || 0}
                            />
                            <AdvanceTable
                              table
                              headerClassName="bg-200 text-900 text-nowrap align-middle"
                              rowClassName={`align-middle white-space-nowrap ${
                                activeSubscriptions.length == 0 &&
                                'block-text-blur'
                              }`}
                              tableProps={{
                                size: 'sm',
                                striped: true,
                                className: 'fs--1 mb-0 overflow-hidden'
                              }}
                              // onRowClicked={onRowClicked}
                            />
                          </Card.Body>
                        </Card>
                      </AdvanceTableWrapper>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}
      </>
    );
  };

  const onRowClickedForDetail = (GUID, isFrom) => {
    dispatch(showMasterSignerDialog(GUID, isFrom, res => {}));
  };

  const parsedAuditLogMessage = message => {
    if (!message) {
      return null;
    }

    return (
      <span>
        {message.split(/\*\*/).map((segment, index) => {
          const childMatch = segment.match(/^(.+?)\$\$([0-9a-fA-F-]{36})$/);
          if (childMatch) {
            const fullName = childMatch[1];
            const id = childMatch[2];

            return (
              <span
                key={index}
                style={{ cursor: 'pointer', color: '#1a73e8' }}
                onClick={() => onRowClickedForDetail(id, 'archivedMaster')}
              >
                {fullName}
              </span>
            );
          }

          const parentMatch = segment.match(/^(.+?)##([0-9a-fA-F-]{36})$/);
          if (parentMatch) {
            const fullName = parentMatch[1];
            const id = parentMatch[2];

            return (
              <span
                key={index}
                style={{ cursor: 'pointer', color: '#1a73e8' }}
                onClick={() => onRowClickedForDetail(id, 'master')}
              >
                {fullName}
              </span>
            );
          }

          return <span key={index}>{segment}</span>;
        })}
      </span>
    );
  };

  const renderAuditLog = () => {
    const parsedAuditLog =
      signerList?.Blobs?.length > 0
        ? signerList?.Blobs?.flatMap(blob =>
            blob?.Data ? utils.decodeBlobData(blob.Data) : []
          )
        : null;

    return (
      <>
        {signerList?.Blobs?.length > 0 && (
          <Card className="my-2">
            <Card.Header>
              <h5>
                <FaStickyNote /> Audit Log
              </h5>
            </Card.Header>
            {!parsedAuditLog ? (
              <Card.Body className="p-1 pl-3">
                <p>- Audit Log Not Present -</p>
              </Card.Body>
            ) : (
              <>
                <hr className="my-0" />
                <Card.Body>
                  <ListGroup>
                    {_.map(parsedAuditLog, logItem => {
                      return (
                        <ListGroup.Item key={logItem.audit_log_item_id}>
                          <Flex
                            justifyContent="between"
                            alignItems="center"
                            className="flex-wrap"
                          >
                            {parsedAuditLogMessage(logItem.description)}
                            <SoftBadge pill bg="primary" className="me-2">
                              {' '}
                              {draftEntryUiHelper
                                .getDateTimeWithTimeZone(
                                  logItem.timestamp,
                                  store.getState()?.app?.userMaster
                                    ?.LocalTimezone
                                )
                                .format(c.dateFormat)}
                            </SoftBadge>
                          </Flex>
                        </ListGroup.Item>
                      );
                    })}
                  </ListGroup>
                </Card.Body>
              </>
            )}
          </Card>
        )}
      </>
    );
  };

  const closeModal = res => {
    SetIsDisplayProfilePic(false);
    close(res);
  };

  return (
    <>
      <ModalHeader
        toggle={() => {
          closeModal(changesMade);
        }}
      >
        Client Details
      </ModalHeader>
      <ModalBody>
        {loading && (
          <Flex
            className="vh-100"
            direction="column"
            justifyContent="center"
            alignItems="center"
            alignContent="center"
          >
            <div className="text-center w-75">
              <Alert color="light">
                <Spinner color="success" />
              </Alert>
            </div>
            <div className="w-75 text-center">
              <Placeholder xs={6} />
              <Placeholder className="w-75" />
              <Placeholder className="w-50" />
              <Placeholder className="w-50" />
              <Placeholder className="w-75" />
            </div>
          </Flex>
        )}
        {!loading ? (
          <div className="m-3">
            {renderSigner()}
            {renderIdentifications()}
            {renderAuditLog()}
            {renderJournalDetails()}
          </div>
        ) : (
          <div className="m-3">
            <Flex justifyContent="center">
              <Spinner size="sm" /> &nbsp; Loading...
            </Flex>
          </div>
        )}
      </ModalBody>
      <ModalFooter className="justify-content-center align-items-center">
        {!loading && (
          <>
            <Button
              variant="danger"
              onClick={() => {
                closeModal(changesMade);
              }}
            >
              Close
            </Button>
          </>
        )}
      </ModalFooter>
    </>
  );
};
export default ViewEntryDialog;
